<template>
  <a-dropdown>
    <a
      class="ant-dropdown-link"
      style="color:#ccc;"
      @click="e => e.preventDefault()">
      <a-avatar :size="48" :src="userInfo.avatar" />
      <a-icon type="down" />
    </a>
    <a-menu slot="overlay">
      <a-menu-item>
        <a href="javascript:;">{{userInfo.username}}</a>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="#" @click="logout">退出</a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import userModel from '@/api/user'
export default {
  components: {

  },
  data () {
    return {
      userInfo: {}
    }
  },
  created () {
    this.update()
  },
  methods: {
    update () {
      const self = this
      userModel.getUserInfo().then(res => {
        self.userInfo = res.data
      }, err => {
        if (err && err.status === 401) {
          this.$router.push('/login')
        }
      })
    },
    logout () {
      userModel.logout().then(() => {
        window.localStorage['authorization'] = ''
        this.$router.push('/login')
      }, () => {
        window.localStorage['authorization'] = ''
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/home/UserInfo.vue